(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('PlayIntegrityLogDialogController', PlayIntegrityLogDialogController);

    PlayIntegrityLogDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'PlayIntegrityLog'];

    function PlayIntegrityLogDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, PlayIntegrityLog) {
        var vm = this;

        vm.playIntegrityLog = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.playIntegrityLog.id !== null) {
                PlayIntegrityLog.update(vm.playIntegrityLog, onSaveSuccess, onSaveError);
            } else {
                PlayIntegrityLog.save(vm.playIntegrityLog, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:playIntegrityLogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
